import { useMemo, useState } from "react"
import { Service } from "./../types"

export function useServiceForm(service: Service | null) {
    const [form, setForm] = useState<Partial<Service>>({})

    const currentValues = useMemo<Service>(() => {
        return {
            id: form?.id ?? service?.id,
            automated_service_name: form?.automated_service_name ?? service?.automated_service_name ?? '',
            path: form?.path ?? service?.path ?? '',
            triggers: form?.triggers ?? service?.triggers ?? [],
        }
    }, [form, service])

    const isFormSubmittable = useMemo(() => {
        return currentValues.automated_service_name && currentValues.path && currentValues.triggers.length > 0
    }, [currentValues])

    return {
        currentValues,
        setForm,
        isFormSubmittable
    }

}